import React, { useEffect, useRef, useState } from 'react';
import { googleTranslate } from '../../scripts/translate.js';
import Header from '../../components/Header';
import HeaderBar from '../../components/HeaderBar';
import Loader from '../../components/Loader';
import RightNav from '../../components/RightNav';
import Menu from '../../components/Menu';
import Footer from '../../components/Footer';
import FAQModal from '../../components/Modals/FAQ';
import { FaArrowUp } from 'react-icons/fa';
import './style.scoped.scss';
import {
  ROUTES,
  USER,
  notification,
  setElementHeights,
} from '../../assets/constants/strings';
import $ from 'jquery';
import {
  GetUserQueries,
  CreateNewMessage,
  CreateNewQuery,
  DeleteQuery,
  UpdateQueryTitle,
  GetAiResponse,
  UpdateQuery,
  UpdateResponse,
  UpdateQueryUserMessage,
} from '../../store/Revealr/revealrActions.js';
import QueryList from '../../components/RevealrQueries/QueryList';
import QueryType from '../../components/RevealrQueries/QueryType';
import Messages from '../../components/RevealrQueries/Messages';
import { saveAs } from 'file-saver';
import MessageInput from '../../components/RevealrQueries/Input';
import { TbLayoutSidebarLeftExpandFilled } from 'react-icons/tb';
import DocListModal from '../../components/DocList';
import { connect } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Redirect } from 'react-router-dom';
import { UpdateUserUsage } from '../../store/Paddle/paddleActions.js';

const mapState = (state) => ({
  queries: state.queries.queries,
  queriesLoading: state.queries.loading,
  currentDoc: state.document.currentDocument,
  user: state.user.user,
});

const connector = connect(mapState, {
  GetUserQueries,
  CreateNewQuery,
  DeleteQuery,
  CreateNewMessage,
  UpdateQueryTitle,
  GetAiResponse,
  UpdateQuery,
  UpdateResponse,
  UpdateQueryUserMessage,
  UpdateUserUsage,
});

const QueryPage = ({
  queriesLoading,
  queries,
  currentDoc,
  user,
  GetUserQueries,
  CreateNewQuery,
  DeleteQuery,
  CreateNewMessage,
  UpdateQueryTitle,
  GetAiResponse,
  UpdateResponse,
  UpdateQueryUserMessage,
  UpdateQuery,
  UpdateUserUsage,
}) => {
  const [isRightNavVisible, setIsRightNavVisible] = useState(
    window.innerWidth > 950
  );
  const [FAQuestion, setFAQuestion] = useState(0);
  const [displayName, setDisplayName] = useState('');
  const [message, setMessage] = useState('');
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [deleteChat, setDeleteChat] = useState(null);
  const [deleteOptions, setDeleteOptions] = useState({});
  const [newTitle, setNewTitle] = useState('');
  const [editOptions, setEditOptions] = useState({});
  const [inputDisabled, setInputDisabled] = useState(true);
  const [typing, setTyping] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 950);
  const [searchQuery, setSearchQuery] = useState('');

  const apiTimeout = 45000;

  const [selectedLevel, setSelectedLevel] = useState(null);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  // useEffect(() => {
  //   const rightNav = document.getElementById('right-nav');
  //   rightNav.style.maxWidth = '20%';

  //   const rightNavCards = document.getElementsByClassName('wf-card');
  //   for (let i = 0; i < rightNavCards.length; i++) {
  //     const card = rightNavCards[i];
  //     card.style.width = '14vw';
  //   }
  // }, [isRightNavVisible]);

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 950;

    setIsSmallScreen(screenRef.current);
  };

  useEffect(() => {
    if (isVisible && isSmallScreen) setIsVisible(false);
  }, []);

  useEffect(() => {
    if (queries === null) {
      GetUserQueries();
    }

    if (queries && queries.length > 0 && selectedQuery === null)
      setSelectedQuery(queries[0]);
  }, [queries]);

  useEffect(() => {
    if (user && user.displayName) {
      const words = user.displayName.split(' ');
      setDisplayName(
        words
          .map((word) => word[0])
          .join('')
          .toUpperCase()
      );
    }
  }, [user]);

  useEffect(() => {
    if (
      selectedQuery &&
      selectedQuery.docIds &&
      selectedQuery.docIds !== null &&
      !selectedQuery.isFirstTime
    )
      setSelectedDocs(selectedQuery.docIds);

    if (selectedQuery && selectedQuery.isFirstTime) {
      if (currentDoc && currentDoc.id) setSelectedDocs([currentDoc.id]);
      else setSelectedDocs([]);
    }
  }, [selectedQuery]);

  const handleRightNav = (visible) => {
    setIsRightNavVisible(visible);
  };

  const handleSetFAQ = (question) => {
    setFAQuestion(question);
    $('#FAQModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  useEffect(() => {
    $(window).on('resize', setElementHeights);
  }, []);

  useEffect(() => {
    googleTranslate();
  });

  const onClickQuery = (query) => {
    setSelectedQuery(query);
    if (isSmallScreen) setIsVisible(false);
  };

  const createNewQuery = async () => {
    const response = await CreateNewQuery(
      // selectedDocs ? selectedDocs.toString() : '',
      currentDoc && currentDoc.id ? currentDoc.id : ''
    );
    if (response) {
      const list = await GetUserQueries();
      setSelectedQuery(list[0]);
    } else
      notification(
        'danger',
        'Could not create new query. Please try again later.'
      );
  };

  const getLastFiveQueries = (selected) => {
    // Check if queryContent exists and is an array
    if (!selected.queryContent || !Array.isArray(selected.queryContent)) {
      return [];
    }

    // Check if the array has less than 5 items or is empty
    if (selected.queryContent.length <= 5) {
      const formattedItems = selected.queryContent.map((item) => ({
        message: item.message || '',
        response: item.response ? item.response.response || '' : '',
        id: item.id,
      }));
      return formattedItems;
    }

    // Extract the last five items from the queryContent array
    const lastFiveItems = selected.queryContent.slice(-5);

    const formattedItems = lastFiveItems.map((item) => ({
      message: item.message || '',
      response: item.response ? item.response.response || '' : '',
      id: item.id,
    }));

    return formattedItems;
  };

  const handleQuery = async (e) => {
    e.preventDefault();

    const query = message.replace(/^\s+|\s+$/g, '');
    setMessage('');
    setInputDisabled(true);

    // error Response in case call to api fail
    const errorResponse = {
      response: "I'm sorry, but I can't assist with that.",
      source_documents: {},
      title: 'New Query',
    };

    // new content with the message sent by the user
    const content = {
      queryId: selectedQuery.id,
      message: query,
      response: '',
      userMessage: true,
    };

    // create new message on sharepoint QueryMessages list
    const response = await CreateNewMessage(selectedQuery.id, query);

    if (response) {
      if (user.remainingQueries > 0) await UpdateUserUsage(USER.USAGE.QUERIES);
      else if (user.remainingAdditionalQueries > 0)
        await UpdateUserUsage(USER.USAGE.ADDITIONALQUERIES);

      // update query with new message
      const updatedQuery = {
        ...selectedQuery,
        queryContent: [...selectedQuery.queryContent, content],
      };
      setSelectedQuery(updatedQuery);

      const newMessageIdCreated = response.success.id;
      // console.log('newMessageIdCreated', newMessageIdCreated);

      // if the queryContent > 0 we only need to update the message and response
      if (selectedQuery.queryContent.length > 0) {
        // request for AI
        const apiCall = GetAiResponse(
          query,
          selectedQuery.docIds,
          selectedQuery.id,
          selectedQuery.startedId,
          getLastFiveQueries(selectedQuery),
          selectedQuery.title === '' ||
            selectedQuery.title === 'New Query' ||
            selectedQuery.title === null
            ? true
            : false
        );

        // Use Promise.race to set a timeout for the API call
        const apiCallWithTimeout = Promise.race([
          apiCall,
          new Promise((_, reject) =>
            setTimeout(
              () => reject(new Error('API call timed out')),
              apiTimeout
            )
          ),
        ]);

        try {
          const aiRes = await apiCallWithTimeout;
          // console.log('AI_RES', aiRes);

          // response from AI
          if (aiRes && aiRes.hasOwnProperty('response')) {
            const resResponse = await UpdateResponse(
              newMessageIdCreated,
              aiRes
            );

            // update selected query with response from AI
            if (resResponse) {
              let newTitle = selectedQuery.title;
              if (aiRes.title) {
                newTitle = aiRes.title.replace('Title: ', '');
                const columnRes = await UpdateQuery(
                  selectedQuery.id,
                  newTitle,
                  selectedQuery.docIds
                );

                if (columnRes)
                  await UpdateQueryTitle(selectedQuery.id, newTitle);
              }

              content.response = aiRes;
              const updatedQueryWithResponse = {
                ...updatedQuery,
                title: newTitle,
                queryContent: [
                  ...updatedQuery.queryContent.slice(0, -1),
                  content,
                ],
              };
              setSelectedQuery(updatedQueryWithResponse);
            }
          } else {
            const resResponse = await UpdateResponse(
              newMessageIdCreated,
              errorResponse
            );

            // update selected query with error response
            if (resResponse) {
              content.response = JSON.parse(JSON.stringify(errorResponse));
              const updatedQueryWithResponse = {
                ...updatedQuery,
                queryContent: [
                  ...updatedQuery.queryContent.slice(0, -1),
                  content,
                ],
              };
              setSelectedQuery(updatedQueryWithResponse);
            }
          }
        } catch (error) {
          const resResponse = await UpdateResponse(
            newMessageIdCreated,
            errorResponse
          );

          // update selected query with error response
          if (resResponse) {
            content.response = JSON.parse(JSON.stringify(errorResponse));
            const updatedQueryWithResponse = {
              ...updatedQuery,
              queryContent: [
                ...updatedQuery.queryContent.slice(0, -1),
                content,
              ],
            };
            setSelectedQuery(updatedQueryWithResponse);
          }
        }
      } else {
        // updates selected docs and UI
        updateUiFirstTime(content);

        // request for AI
        const apiCall = GetAiResponse(
          query,
          selectedDocs,
          selectedQuery.id,
          selectedQuery.docIds,
          getLastFiveQueries(selectedQuery),
          true
        );

        // Use Promise.race to set a timeout for the API call
        const apiCallWithTimeout = Promise.race([
          apiCall,
          new Promise((_, reject) =>
            setTimeout(
              () => reject(new Error('API call timed out')),
              apiTimeout
            )
          ),
        ]);

        try {
          const aiRes = await apiCallWithTimeout;

          // update response on sharepoint QueryMessages list
          if (aiRes && aiRes.hasOwnProperty('response')) {
            const resResponse = await UpdateResponse(
              newMessageIdCreated,
              aiRes
            );

            if (resResponse) {
              let newTitle = selectedQuery.title;
              if (aiRes.title) {
                newTitle = aiRes.title.replace('Title: ', '');
                const columnRes = await UpdateQuery(
                  selectedQuery.id,
                  newTitle,
                  selectedDocs
                );

                if (columnRes)
                  await UpdateQueryTitle(selectedQuery.id, newTitle);
              }

              content.response = aiRes;
              const updatedQueryWithResponse = {
                ...selectedQuery,
                docIds: selectedDocs,
                title: newTitle,
                isFirstTime: false,
                queryContent: [
                  ...selectedQuery.queryContent.slice(0, -1),
                  content,
                ],
              };
              setSelectedQuery(updatedQueryWithResponse);

              const updateUserMessage = {
                ...updatedQueryWithResponse,
                userMessage: false,
              };
              setSelectedQuery(updateUserMessage);
            }
          } else {
            const resResponse = await UpdateResponse(
              newMessageIdCreated,
              errorResponse
            );

            // update selected query with error response
            if (resResponse) {
              content.response = JSON.parse(JSON.stringify(errorResponse));
              const updatedQueryWithResponse = {
                ...updatedQuery,
                isFirstTime: false,
                queryContent: [
                  ...updatedQuery.queryContent.slice(0, -1),
                  content,
                ],
              };
              setSelectedQuery(updatedQueryWithResponse);
            }
          }
        } catch (error) {
          // showToast('error', 'Please, try again later.');
          const resResponse = await UpdateResponse(
            newMessageIdCreated,
            errorResponse
          );

          // update selected query with error response
          if (resResponse) {
            content.response = JSON.parse(JSON.stringify(errorResponse));
            const updatedQueryWithResponse = {
              ...updatedQuery,
              isFirstTime: false,
              queryContent: [
                ...updatedQuery.queryContent.slice(0, -1),
                content,
              ],
            };
            setSelectedQuery(updatedQueryWithResponse);
          }
        }
      }
    } else notification('danger', 'Error sending message. Please try again.');
    setInputDisabled(false);
  };

  const updateUiFirstTime = async (content) => {
    const res = await UpdateQuery(
      selectedQuery.id,
      selectedQuery.title,
      selectedDocs
    );

    if (res) {
      const updatedQuery = {
        ...selectedQuery,
        docIds: selectedDocs,
        queryContent: [...selectedQuery.queryContent, content],
        isFirstTime: false,
      };
      setSelectedQuery(updatedQuery);
    }
  };

  const handleEmail = (e, query) => {
    e.preventDefault();

    const subject = query.title;

    const sourceLinks = (item) => {
      let links = '';
      for (const key in item.response.source_documents) {
        if (item.response.source_documents.hasOwnProperty(key)) {
          const link = item.response.source_documents[key];
          links += `${key}:\n${link}\n\n`;
        }
      }
      return links;
    };

    const body = query.queryContent.map((item) => {
      return `${user.displayName}: ${item.message.replace(/<br\/>/g, '\n')}\n
RevealrAI: ${item.response.response.replace(/<br\/>/g, '\n')}\n
${sourceLinks(item)}`;
    });

    const mailtoURL = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoURL;
  };

  const handleDelete = (e, query) => {
    e.preventDefault();

    const newDeleteOptions = {};
    newDeleteOptions[query.id] = true;

    setDeleteChat(query);
    setDeleteOptions(newDeleteOptions);
  };

  const handleDeleteChat = async (e) => {
    e.preventDefault();

    const response = await DeleteQuery(selectedQuery);
    if (response) {
      notification('success', 'Query deleted successfully.');
      const list = await GetUserQueries();
      if (list && list.length > 0) setSelectedQuery(list[0]);
      else setSelectedQuery();
    } else notification('error', 'Error deleting Query.');
  };

  const handleCloseDelete = (e, chatId) => {
    e.preventDefault();
    setDeleteOptions((prevDeleteOptions) => ({
      ...prevDeleteOptions,
      [chatId]: !prevDeleteOptions[chatId],
    }));
  };

  const handleDownload = (e, query) => {
    e.preventDefault();
    const blob = new Blob([formatDataAsWordDocument(query)], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
    saveAs(blob, `${query.title}.doc`);
  };

  const formatDataAsWordDocument = (query) => {
    let content = '';

    // Loop through the queryContent array and format the content
    query.queryContent.forEach((item) => {
      content += `<b>${user.displayName}:</b> ${item.message}<br/><br/>`;

      // Check if the response contains a table
      if (item.response.response.includes('<table')) {
        // Add a border to the table and apply styles to <tr> and <td>
        const tableWithStyles = item.response.response
          .replace(
            `<table class='custom-table'>`,
            `<table style="border: 1px solid black; width: 100%;">`
          )
          .replace(/<th>/g, `<th style="border: 1px solid black;">`)
          .replace(
            /<td>/g,
            `<td style="padding: 5px; border: 1px solid black;">`
          );
        content += tableWithStyles;
      } else {
        content += `<b>RevealrAI:</b> ${item.response.response}<br/><br/>`;
      }

      if (item.response.source_documents) {
        for (const key in item.response.source_documents) {
          if (item.response.source_documents.hasOwnProperty(key)) {
            const link = item.response.source_documents[key];
            content += `<a href=${link} target="_blank" rel="noreferrer">${key}</a><br/>`;
          }
        }
      }

      content += '<br/><br/>';
    });

    // Return the formatted content as a Word document
    return `<!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Document</title>
        </head>
        <body>
          <h3>${query.title}</h3>
          <div>${content}</div>
        </body>
      </html>`;
  };

  const handleEdit = (e, query) => {
    e.preventDefault();

    const newEditOptions = {};
    newEditOptions[query.id] = true;
    setNewTitle(selectedQuery.title);

    setEditOptions(newEditOptions);
  };

  const handleTitleChange = (value) => {
    setNewTitle(value);
  };

  const handleEditTitle = async (e) => {
    e.preventDefault();
    if (newTitle === '' || newTitle === null)
      notification('danger', 'Query title is empty.');
    else if (newTitle && newTitle.trim() === '')
      notification('danger', 'Query title is empty.');
    else {
      const res = await UpdateQuery(
        selectedQuery.id,
        newTitle,
        selectedQuery.docIds
      );

      if (res) {
        await UpdateQueryTitle(selectedQuery.id, newTitle);
        const updatedQuery = {
          ...selectedQuery,
          title: newTitle,
        };
        setSelectedQuery(updatedQuery);
      }
      notification('success', 'Query title updated successfully.');
    }
    setEditOptions({});
    setNewTitle('');
  };

  const handleOnChange = (value) => {
    setMessage(value);
  };

  const handleFinish = async () => {
    setTyping(false);
    const newData = { ...selectedQuery };
    const lastIndex = newData.queryContent.length - 1;
    newData.queryContent[lastIndex].userMessage = false;
    await UpdateQueryUserMessage(newData);
  };

  const handleCheckbox = (event, data) => {
    setSelectedDocs(data.value);
  };

  useEffect(() => {
    if (selectedDocs && selectedDocs.length > 0) {
      setInputDisabled(false);
    } else setInputDisabled(true);
  }, [selectedDocs]);

  const handleSearchInputChange = (value) => {
    setSearchQuery(value);
    localStorage.setItem('SearchQuery', value);
  };

  const handleLevelSelected = (value, level = 'levelOne') => {
    setSelectedLevel({
      value: value,
      level: level,
    });
    $('#DocsListModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const handleOnDismiss = () => {
    setSelectedLevel(null);
  };

  // if (isCurrentDoc) return <Redirect to={ROUTES.HOME} />;

  if (
    !user ||
    (user && !user.isActive)
    // (user &&
    //   !(user.accountStatus === 'trialing' || user.accountStatus === 'active'))
  ) {
    return <Redirect to={ROUTES.LOGIN} />;
  }

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column'>
          <Header hasNav handleLevelSelected={handleLevelSelected} />

          <HeaderBar
            isQuery={true}
            pageTitle={
              selectedQuery && selectedQuery.title
                ? selectedQuery.title
                : 'Revealr Query'
            }
          />
        </div>
      </nav>

      <main
        role='main'
        className='wf-document mb-0 queriesScreen'
        id='wf-document'
      >
        <div id='main-content' className='w-100 chatContent'>
          <div
            className={`containerChats ${
              !isRightNavVisible && !isSmallScreen ? 'positionAbsolute' : ''
            }`}
          >
            {isVisible ? (
              <div
                className={`recentQueries ${isVisible ? 'visible' : 'hidden'}`}
              >
                {queriesLoading ? (
                  <div className='inner-load'>
                    <Loader />
                  </div>
                ) : (
                  <QueryList
                    selectedQuery={selectedQuery}
                    onClickQuery={onClickQuery}
                    handleEmail={handleEmail}
                    handleDelete={handleDelete}
                    createNewQuery={createNewQuery}
                    deleteOptions={deleteOptions}
                    handleCloseDelete={handleCloseDelete}
                    handleDeleteChat={handleDeleteChat}
                    handleDownload={handleDownload}
                    handleEdit={handleEdit}
                    editOptions={editOptions}
                    handleTitleChange={handleTitleChange}
                    titleValue={newTitle}
                    handleCloseEdit={() => setEditOptions({})}
                    handleEditTitle={handleEditTitle}
                    hideRecentQueries={() => {
                      setIsVisible(false);
                      $('#hide-sidebar').tooltip('hide');
                    }}
                    searchQuery={searchQuery}
                    handleSearchInputChange={handleSearchInputChange}
                    queries={queries}
                    user={user}
                  />
                )}
              </div>
            ) : (
              <OverlayTrigger
                placement='right'
                overlay={
                  <Tooltip id='button-tooltip'>Open Recent Queries</Tooltip>
                }
              >
                <div
                  id='open-sidebar'
                  className='openLeftNav'
                  onClick={() => setIsVisible(true)}
                >
                  <TbLayoutSidebarLeftExpandFilled />
                </div>
              </OverlayTrigger>
            )}
            <div className='queryWrapper'>
              <QueryType
                isEmptyList={queries && queries.length === 0}
                selectedDocs={selectedDocs}
                handleCheckbox={handleCheckbox}
                selectedQuery={selectedQuery}
                isQueryDisabled={selectedQuery && selectedQuery.docIdsExist}
                rigthNavVisible={isRightNavVisible}
                isLoading={queriesLoading}
              />

              {queriesLoading ? (
                <div className='inner-load'>
                  <Loader />
                </div>
              ) : selectedQuery && selectedQuery.queryContent.length > 0 ? (
                <Messages
                  arrayToMap={selectedQuery.queryContent}
                  displayName={displayName}
                  onStartTyping={() => setTyping(true)}
                  onFinishTyping={handleFinish}
                />
              ) : (
                <div id='messagesWrapper'></div>
              )}
              {queries &&
              queries.length > 0 &&
              selectedQuery &&
              selectedQuery.docIdsExist ? (
                <MessageInput
                  user={user}
                  message={message}
                  handleQuery={handleQuery}
                  handleOnChange={handleOnChange}
                  inputDisabled={
                    inputDisabled ||
                    (user.remainingQueries <= 0 &&
                      user.remainingAdditionalQueries <= 0)
                  }
                />
              ) : null}
            </div>
          </div>
        </div>

        <RightNav
          accountPage={true}
          handleVisibility={handleRightNav}
          handleSetFAQ={handleSetFAQ}
        />

        {!isRightNavVisible && (
          <Menu accountPage={true} handleSetFAQ={handleSetFAQ} />
        )}

        <div
          id='scroll-messages-top'
          className='scroll-to-top-wrapper'
          onClick={() => {
            $('#messagesWrapper').scrollTop(0);
            $('#wf-scroll-wrapper').scrollTop(0);
          }}
        >
          <div className='scroll-to-top'>
            <FaArrowUp />
          </div>
        </div>
      </main>

      <DocListModal selectedLevel={selectedLevel} onDismiss={handleOnDismiss} />

      <Footer isDocument isCentered isAbsolute />
      <FAQModal question={FAQuestion} />
    </div>
  );
};

export default connector(QueryPage);
